import React from "react";

import CustomSelect from "components/common/select/SelectField";
import SearchField from "components/common/customSearchField/CustomSearchField";

import "./VdsUser.scss";
import InviteUser from "../InviteUser";
import ActionBar from "components/common/tableFilters/ActionBar";
import { useTranslation } from "react-i18next";
const VdsUserActionBar = ({
  handleChange,
  handleSubmit,
  orderByList,
  filters,
  resetFilters,
}) => {
  const { t } = useTranslation();
  return (
    <div className="maindiv d-flex justify-content-between align-items-end mt-3">
      <div className="vdsuser d-flex w-100">
        <ActionBar
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          orderByList={orderByList}
          resetFilters={resetFilters}
          searchPlaceholder={t("user-name")}
          filters={filters}
          // showAddButton={true}
          // text={t("invite-user")}
          // path="/user-management/add-user"
        />
      </div>
    </div>
  );
};

export default VdsUserActionBar;
